module.exports = __webpack_public_path__ + "static/media/Big-Data-Vs-Machine-Learning.4d0e2a1a.png";